module.exports = __webpack_public_path__ + "img/list_subtitle.dfe6f60c.png";